export const hideHeaderAndFooter = () => {
  const elementsToHide = [
    "div.newsPanel",
    "footer.pageFooter",
    "legacy-header-element",
  ];
  elementsToHide.forEach((el) => {
    const element = document.querySelector(el) as HTMLDivElement;
    element.style.display = "none";
  });
  const cover = document.querySelector("div.cover") as HTMLDivElement;
  cover.style.minHeight = "unset";

  const toolbar = document.querySelector(".toolBar") as HTMLDivElement;
  toolbar.style.height = "60px";

  const headerAnchors: NodeListOf<any> =
    document.querySelectorAll(".toolBar a");
  Array.from(headerAnchors).forEach((a) => {
    a.style.color = "black";
  });
  setTimeout(() => {
    const personalBlockRegular = document.querySelector(
      "div.personalBlockRegular"
    ) as HTMLDivElement;
    if (personalBlockRegular && personalBlockRegular.style) {
      personalBlockRegular.style.top = "20px";
    }
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, 500);
};



// WEBPACK FOOTER //
// ./src/app/_helpers/hide-header-and-footer.ts